const modelListItemMixin = {
  props: ['model'],
  methods: {
    onItemClick(item) {
      this.$emit('onItemClick');
    },
  }
}

export default modelListItemMixin;